module.exports = __webpack_public_path__ + "static/card8-03ffb611a21ebc435b6f60348d389ac9.png";